import React, { useEffect, useRef } from 'react';

import { ensureTrustpilotBootstrap } from './ensureTrustpilotBootstrap';

const BUSINESS_UNIT_ID = '60c847b7f033d300019ff3a1';
const TEMPLATE_ID = '5419b732fbfb950b10de65e5';

const TOKENS = {
  desktop: '68162ef9-8319-42e2-aa33-76ec18011c2c',
  mobile: '51786a71-451b-4c5d-a09e-c2802af5899f',
} as const;

const TrustBoxWidget: React.FC<{
  token: string;
  className?: string;
}> = ({ token, className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let cancelled = false;

    ensureTrustpilotBootstrap()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {
        // bootstrap 加载失败时保留占位链接，不阻断页面
      });

    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div
      ref={ref}
      className={`trustpilot-widget ${className ?? ''}`}
      data-locale="en-US"
      data-template-id={TEMPLATE_ID}
      data-businessunit-id={BUSINESS_UNIT_ID}
      data-style-height="24px"
      data-style-width="100%"
      data-token={token}>
      <a
        href="https://www.trustpilot.com/review/wukongsch.com"
        target="_blank"
        rel="noopener">
        Trustpilot
      </a>
    </div>
  );
};

/**
 * Trustpilot 官方 TrustBox：Micro Star（不显示评分数字）
 * 桌面端 / 移动端使用后台分别生成的 token；bootstrap 由组件内部加载
 */
const TrustpilotMicroStar: React.FC<{
  className?: string;
}> = ({ className }) => {
  return (
    <div className={className}>
      <TrustBoxWidget token={TOKENS.mobile} className="lg:hidden" />
      <TrustBoxWidget token={TOKENS.desktop} className="hidden lg:block" />
    </div>
  );
};

export default TrustpilotMicroStar;
